import type { ReactNode } from 'react';

import { ShowPhoneNumberButton } from '../../../../components/Toolkit/ShowPhoneNumberButton/ShowPhoneNumberButton';
import type { SellerTypes } from '../../../../components/PageWrappers/AdDetails/types';

import { useRevealPhoneNumber } from './useRevealPhoneNumber';

interface RevealPhoneNumberProps {
  adId: number;
  showNumberTextVariant?: boolean;
  size?: 'SMALL' | 'LARGE' | 'GROW';
  trackingId?: string;
  clickSource?: string;
  isPrimaryButton?: boolean;
  campaignId?: string | null;
  disabled?: boolean;
  sectionName?: string;
  sellerType?: SellerTypes;
  id?: string;
  price?: string | null;
  children?: ReactNode;
}

function RevealPhoneNumber({
  adId,
  showNumberTextVariant = false,
  size = 'SMALL',
  trackingId = 'reveal-number',
  clickSource = '',
  isPrimaryButton = false,
  campaignId,
  sectionName,
  sellerType,
  price,
  ...rest
}: RevealPhoneNumberProps) {
  const { handleReveal, handleOnCall } = useRevealPhoneNumber({
    adId,
    clickSource,
    campaignId,
    sectionName,
    sellerType,
    price,
  });

  return (
    <ShowPhoneNumberButton
      adId={adId}
      onReveal={handleReveal}
      showNumberTextVariant={showNumberTextVariant}
      size={size}
      trackingId={trackingId}
      onCall={handleOnCall}
      isPrimaryButton={isPrimaryButton}
      {...rest}
    />
  );
}

export { RevealPhoneNumber, type RevealPhoneNumberProps };
